<template>
  <div class="promotion-code">
    <div class="promotion-code__title" :class="{ 'active-title': isActive }">
      {{ $t("booking.promo_code") }}
    </div>
    <div class="promotion-code__input" @click="showPromoCode">
      <div class="promotion-code__input__icon promotion-code__input--icon">
        <span class="icon-Icon-Promo-Codes" />
      </div>
      <input
        ref="input"
        v-model="promoCode"
        type="text"
        maxlength="10"
        placeholder="------"
        @input="onInput"
      />
      <div
        class="promotion-code__input__status promotion-code__input--icon"
        v-if="promoCode"
      >
        <span class="icon-Icon-Close" @click="onClearSearchText" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "PromotionCode",
  props: {
    isActive: {
      type: Boolean,
    },
  },
  data() {
    return {
      promoCode: "",
      promoCodeExist: false,
    };
  },
  mounted() {
    this.promoCode = this.promotionCode;
  },
  computed: {
    ...mapState({
      promotionCode: (state) => state.bookingData.promoCode,
      promoCodeState: (state) => state.bookingState.promoCode,
    }),
  },
  watch: {
    promoCodeState(isActive) {
      if (isActive) {
        this.$refs["input"].focus();
      }
    },
    promotionCode(code){
      this.promoCode = code
    },
    // promoCode(promoCode) {
    //   const route = this.$route;
    //   this.$router
    //     .push({
    //       path: route.path,
    //       query: {
    //         ...route.query,
    //         promoCode: this.promoCode,
    //       },
    //     })
    //     .catch((err) => console.log(err));
    // },
  },
  methods: {
    ...mapActions({
      closeAll: "closeAll",
      savePromoCode: "savePromoCode",
      showPromoCode: "showPromoCode",
    }),
    onInput() {
      this.savePromoCode(this.promoCode);
    },
    setPromoCode() {},

    onClearSearchText() {
      this.promoCode = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.error {
  border: 2px solid red;
}
.promotion-code {
  &__title {
    display: none;
    color: #232e48;
    font-size: 13px;
    margin-bottom: 12px;
    text-align: center;
    @include min-sm {
      display: block;
      white-space: nowrap;
    }
  }
  &__input {
    position: relative;
    background: white;
    input {
      width: 100%;
      height: 50px;
      border: 2px solid #e4e4e7;
      text-transform: uppercase;
      font-weight: 600;
      outline: none;
      padding-left: 48px;
      background: white;
      @include min-sm {
        height: 58px;
        text-align: center;
        max-width: 96px;
        padding-left: initial;
        padding: 0 5px;
      }
      &::placeholder {
        color: white;
        opacity: 0.75;
        letter-spacing: 4px;
        font-size: 12px;
        @include min-sm {
          color: #7b7b85;
        }
      }
    }
    &--icon {
      position: absolute;
      top: 15px;
      @include min-sm {
        display: none;
      }
    }
    &__icon {
      left: 15px;
    }
    &__status {
      right: 15px;
    }
    .icon-Icon-Close {
      color: #1a489c;
      position: absolute;
      right: 0px;
      top: 2px;
      font-size: 7px;
      padding: 5px;
      color: white;
      border-radius: 50%;
      background: #8a92a3;
      font-weight: bold;
    }
  }
}
</style>
